import React, { useState } from "react";
import getModalStyle from "../../../../util/getModalStyle";

function useConfirmSignSelector(handleSign: () => void) {
  const [modalStyle] = useState(() => getModalStyle(50, 50));

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      return handleSign();
    }
  };

  return {
    modalStyle,
    handleKeyDown,
  };
}

export default useConfirmSignSelector;
